'use strict';

var _extends = require('../../../node_modules/@babel/runtime/helpers/extends.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var withStyles = require('../../Styles/withStyles.js');
require('prop-types');
var classNames = require('classnames');
var Fab = require('../../../node_modules/@material-ui/core/esm/Fab/Fab.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var styles = function styles(theme) {
  return {
    container: {
      height: 40,
      minWidth: 'auto',
      cursor: 'default',
      backgroundColor: theme.palette.common.white,
      padding: 0,
      '&:active': {
        boxShadow: theme.shadows[5]
      },
      '&:hover': {
        backgroundColor: theme.palette.common.white
      }
    }
  };
};

var FloatingActionButton = function FloatingActionButton(_ref) {
  var variant = _ref.variant,
      classes = _ref.classes,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ["variant", "classes", "className"]);

  var container = classes.container,
      otherClasses = objectWithoutProperties(classes, ["container"]);

  if (variant === "container") {
    return React__default["default"].createElement(Fab["default"], _extends["default"]({
      disableFocusRipple: true,
      disableRipple: true,
      variant: "extended",
      component: "div",
      className: classNames__default["default"](container, className)
    }, props));
  }

  return React__default["default"].createElement(Fab["default"], _extends["default"]({
    variant: variant,
    classes: otherClasses,
    className: className
  }, props));
};

FloatingActionButton.defaultProps = {
  variant: "round"
};
var FloatingActionButton$1 = withStyles["default"](styles)(FloatingActionButton);

module.exports = FloatingActionButton$1;
